import React from "react";
import { PageHero } from "../components/PageHero";
import { useLang } from "../i18n";
import { siteConfig, orComingSoon } from "../config/siteConfig";

const copy = {
  en: {
    over: "Legal", title: "Privacy Policy",
    badge: "Draft — full policy coming soon",
    intro: "This is a preliminary Privacy Policy for WANM — We Are Nation Media. A complete, legally reviewed policy will be published once WANM's official corporate details and business email are established. In the meantime, this page describes our current, limited data practices.",
    sections: [
      { h: "Information we collect", p: "When you submit a form on this website (brand inquiry, publisher application or contact), we collect the details you provide — such as your name, company, email and message — solely to respond to your request." },
      { h: "How we use information", p: "We use submitted information only to evaluate and respond to partnership and contact requests. We do not sell your personal information." },
      { h: "Cookies", p: "We use a minimal set of strictly necessary cookies, and optional analytics/marketing technologies only with your consent. See the Cookie Policy for details." },
      { h: "Data retention", p: "We retain form submissions for as long as necessary to handle your request and for legitimate business follow-up." },
      { h: "Your rights", p: "You may request access to, correction of, or deletion of the information you have submitted by contacting us." },
      { h: "Contact", p: "For privacy questions, contact us at:" },
    ],
  },
  es: {
    over: "Legal", title: "Política de Privacidad",
    badge: "Borrador — política completa próximamente",
    intro: "Esta es una Política de Privacidad preliminar de WANM — We Are Nation Media. Se publicará una política completa y revisada legalmente una vez que se establezcan los datos corporativos oficiales y el correo de negocio de WANM. Mientras tanto, esta página describe nuestras prácticas de datos actuales y limitadas.",
    sections: [
      { h: "Información que recopilamos", p: "Cuando envías un formulario en este sitio (consulta de marca, solicitud de publisher o contacto), recopilamos los datos que proporcionas —como nombre, empresa, correo y mensaje— únicamente para responder a tu solicitud." },
      { h: "Cómo usamos la información", p: "Usamos la información enviada solo para evaluar y responder solicitudes de alianza y contacto. No vendemos tu información personal." },
      { h: "Cookies", p: "Usamos un conjunto mínimo de cookies estrictamente necesarias, y tecnologías opcionales de analítica/marketing solo con tu consentimiento. Consulta la Política de Cookies para más detalles." },
      { h: "Conservación de datos", p: "Conservamos los envíos de formularios durante el tiempo necesario para atender tu solicitud y para un seguimiento comercial legítimo." },
      { h: "Tus derechos", p: "Puedes solicitar acceso, corrección o eliminación de la información que has enviado contactándonos." },
      { h: "Contacto", p: "Para consultas de privacidad, contáctanos en:" },
    ],
  },
};

const PrivacyPolicy = () => {
  const { lang } = useLang();
  const c = copy[lang] || copy.en;
  const email = orComingSoon(siteConfig.legal.contactEmail || siteConfig.contact.email);
  return (
    <div>
      <PageHero over={c.over} title={c.title} />
      <section className="py-16 md:py-24 bg-white">
        <div className="mx-auto max-w-3xl px-5 md:px-10">
          <span className="inline-block text-xs font-black uppercase tracking-widest text-wanm-orange bg-wanm-offwhite rounded-full px-4 py-2 mb-8">{c.badge}</span>
          <p className="text-lg text-wanm-dark/70 leading-relaxed mb-10">{c.intro}</p>
          <div className="space-y-10">
            {c.sections.map((s, i) => (
              <div key={i}>
                <h2 className="text-2xl md:text-3xl font-black text-wanm-dark mb-3">{s.h}</h2>
                <p className="text-wanm-dark/70 leading-relaxed text-lg">{s.p}</p>
                {(s.h === "Contact" || s.h === "Contacto") && <p className="mt-2 font-bold text-wanm-red">{email}</p>}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
